// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TagBadge_badge__5kiJW {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
  background: #f4f5f7;
  border: 1px solid #dbdbdb;
}

.TagBadge_tag_active__EG3t5 {
  background: rgba(59, 127, 212, 0.15);
  border-color: rgba(59, 127, 212, 0.4);
}

.TagBadge_tag_historic__3HZ3j {
  background: rgba(142, 106, 203, 0.15);
  border-color: rgba(142, 106, 203, 0.4);
}

.TagBadge_tag_fresh__ntX6y {
  background: rgba(87, 188, 143, 0.15);
  border-color: rgba(87, 188, 143, 0.4);
}

.TagBadge_tag_stale__qX4R4 {
  background: rgba(239, 161, 44, 0.15);
  border-color: rgba(239, 161, 44, 0.4);
}

.TagBadge_tag_never__eWK7w {
  background: rgba(223, 103, 103, 0.15);
  border-color: rgba(223, 103, 103, 0.4);
}

.TagBadge_tag_pf-fresh__YlEZC {
  background: rgba(87, 188, 143, 0.15);
  border-color: rgba(87, 188, 143, 0.4);
}

.TagBadge_tag_pf-semifresh__NOcc7 {
  background: rgba(190, 200, 70, 0.18);
  border-color: rgba(190, 200, 70, 0.5);
}

.TagBadge_tag_pf-stale__Aonka {
  background: rgba(239, 161, 44, 0.15);
  border-color: rgba(239, 161, 44, 0.4);
}

.TagBadge_tag_pf-never__d8\\+eX {
  background: rgba(223, 103, 103, 0.15);
  border-color: rgba(223, 103, 103, 0.4);
}

.TagBadge_status_ACTIVE__Q6wzU {
  background: transparent;
  border-color: rgba(87, 188, 143, 0.8);
}

.TagBadge_status_CREATED__sNAbT {
  background: transparent;
  border-color: rgba(59, 127, 212, 0.8);
}

.TagBadge_status_DISABLED__Dp6P0 {
  background: transparent;
  border-color: rgba(223, 103, 103, 0.8);
}

.TagBadge_tag_historic-sending__puCLu {
  background: rgba(142, 106, 203, 0.3);
  border-color: rgba(142, 106, 203, 0.8);
}

.TagBadge_since__apgZH {
  background: transparent;
  border-style: dashed;
  border-color: rgba(142, 106, 203, 0.6);
  text-transform: none;
}

.TagBadge_tag_new__mIh\\+- {
  background: rgba(70, 190, 210, 0.15);
  border-color: rgba(70, 190, 210, 0.5);
}

.TagBadge_tag_abandoned__OHrvo {
  background: rgba(120, 120, 120, 0.15);
  border-color: rgba(120, 120, 120, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/TagBadge/TagBadge.module.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAGA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBCLS;EDMT,yBAAA;AAFF;;AAKA;EAAgB,oCAAA;EAAsC,qCAAA;AAAtD;;AACA;EAAgB,qCAAA;EAAuC,sCAAA;AAIvD;;AAHA;EAAgB,oCAAA;EAAsC,qCAAA;AAQtD;;AAPA;EAAgB,oCAAA;EAAsC,qCAAA;AAYtD;;AAXA;EAAgB,qCAAA;EAAuC,sCAAA;AAgBvD;;AAfA;EAAoB,oCAAA;EAAsC,qCAAA;AAoB1D;;AAnBA;EAAoB,oCAAA;EAAsC,qCAAA;AAwB1D;;AAvBA;EAAoB,oCAAA;EAAsC,qCAAA;AA4B1D;;AA3BA;EAAoB,qCAAA;EAAuC,sCAAA;AAgC3D;;AA7BA;EAAmB,uBAAA;EAAyB,qCAAA;AAkC5C;;AAjCA;EAAmB,uBAAA;EAAyB,qCAAA;AAsC5C;;AArCA;EAAmB,uBAAA;EAAyB,sCAAA;AA0C5C;;AAxCA;EAAwB,oCAAA;EAAsC,sCAAA;AA6C9D;;AA3CA;EACE,uBAAA;EACA,oBAAA;EACA,sCAAA;EACA,oBAAA;AA8CF;;AA3CA;EAAiB,oCAAA;EAAsC,qCAAA;AAgDvD;;AA/CA;EAAiB,qCAAA;EAAuC,sCAAA;AAoDxD","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.badge {\n  display: inline-block;\n  padding: 1px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n  background: $grey-100;\n  border: 1px solid $grey-200;\n}\n\n.tag_active   { background: rgba(59, 127, 212, 0.15); border-color: rgba(59, 127, 212, 0.4); }\n.tag_historic { background: rgba(142, 106, 203, 0.15); border-color: rgba(142, 106, 203, 0.4); }\n.tag_fresh    { background: rgba(87, 188, 143, 0.15); border-color: rgba(87, 188, 143, 0.4); }\n.tag_stale    { background: rgba(239, 161, 44, 0.15); border-color: rgba(239, 161, 44, 0.4); }\n.tag_never    { background: rgba(223, 103, 103, 0.15); border-color: rgba(223, 103, 103, 0.4); }\n.tag_pf-fresh     { background: rgba(87, 188, 143, 0.15); border-color: rgba(87, 188, 143, 0.4); }\n.tag_pf-semifresh { background: rgba(190, 200, 70, 0.18); border-color: rgba(190, 200, 70, 0.5); }\n.tag_pf-stale     { background: rgba(239, 161, 44, 0.15); border-color: rgba(239, 161, 44, 0.4); }\n.tag_pf-never     { background: rgba(223, 103, 103, 0.15); border-color: rgba(223, 103, 103, 0.4); }\n\n// center-status: outlined, so it is not mistaken for a freshness tag\n.status_ACTIVE   { background: transparent; border-color: rgba(87, 188, 143, 0.8); }\n.status_CREATED  { background: transparent; border-color: rgba(59, 127, 212, 0.8); }\n.status_DISABLED { background: transparent; border-color: rgba(223, 103, 103, 0.8); }\n\n.tag_historic-sending { background: rgba(142, 106, 203, 0.3); border-color: rgba(142, 106, 203, 0.8); }\n\n.since {\n  background: transparent;\n  border-style: dashed;\n  border-color: rgba(142, 106, 203, 0.6);\n  text-transform: none;\n}\n\n.tag_new       { background: rgba(70, 190, 210, 0.15); border-color: rgba(70, 190, 210, 0.5); }\n.tag_abandoned { background: rgba(120, 120, 120, 0.15); border-color: rgba(120, 120, 120, 0.5); }\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `TagBadge_badge__5kiJW`,
	"tag_active": `TagBadge_tag_active__EG3t5`,
	"tag_historic": `TagBadge_tag_historic__3HZ3j`,
	"tag_fresh": `TagBadge_tag_fresh__ntX6y`,
	"tag_stale": `TagBadge_tag_stale__qX4R4`,
	"tag_never": `TagBadge_tag_never__eWK7w`,
	"tag_pf-fresh": `TagBadge_tag_pf-fresh__YlEZC`,
	"tag_pf-semifresh": `TagBadge_tag_pf-semifresh__NOcc7`,
	"tag_pf-stale": `TagBadge_tag_pf-stale__Aonka`,
	"tag_pf-never": `TagBadge_tag_pf-never__d8+eX`,
	"status_ACTIVE": `TagBadge_status_ACTIVE__Q6wzU`,
	"status_CREATED": `TagBadge_status_CREATED__sNAbT`,
	"status_DISABLED": `TagBadge_status_DISABLED__Dp6P0`,
	"tag_historic-sending": `TagBadge_tag_historic-sending__puCLu`,
	"since": `TagBadge_since__apgZH`,
	"tag_new": `TagBadge_tag_new__mIh+-`,
	"tag_abandoned": `TagBadge_tag_abandoned__OHrvo`
};
export default ___CSS_LOADER_EXPORT___;
